export default "/images/vendor/flag-icons/flags/1x1/yt.svg?db71201b57772674af44f62f205d3b04";